import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';

export class FIELD__any__ml_asset extends FIELD_PRIMITIVE__string_hash_ml_asset {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ANY__ML_ASSET;

  /*
   *
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.ANY__ML_ASSET;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return '';
  }

  constructor() {
    super();

    this.populate_enabled = false;
    this.is_empty_allowed = true;
  }
}
